import { Typography } from '../primitives';
import { PasswordStrengthHook } from './PasswordStrengthHook';
import { useTranslation } from '@rpi/i18n';
import clsx from 'clsx';
import React from 'react';

interface PasswordStrengthIndicatorProps {
  password: string;
}

const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> = ({
  password,
}) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.auth' });
  const { strength, strengthText, bgColor, textColor } =
    PasswordStrengthHook(password);
  // Need to update aria labels https://blurb-books.atlassian.net/browse/BLT-968
  return (
    <div>
      <Typography as="p" variant="footnote">
        {t('password_requirements')}
      </Typography>
      <div
        className="flex mt-4 mb-2 h-1 gap-1 overflow-hidden"
        aria-hidden="true"
      >
        {[...Array(4)].map((_, i) => (
          <div
            key={i}
            className={clsx(
              'flex-1',
              i < strength ? bgColor() : 'bg-gray-light',
            )}
          />
        ))}
      </div>
      <Typography
        as="p"
        aria-hidden="true"
        variant="footnote"
        className={clsx('text-right', textColor())}
      >
        {strengthText() || <>&nbsp;</>}
      </Typography>
    </div>
  );
};
export { PasswordStrengthIndicator };
